import React from "react";
import { Link } from "react-router-dom";
import { Component } from "react";
import { withTranslation } from 'react-i18next';
import * as myConstList from "../Common/BaseUrl";
import axios from "axios";
import LoginHeader from "../Common/LoginHeader";
import Footer from "../Common/Footer";
import DocumentMeta from "react-document-meta";
import Moment from "moment";
import Popup from "reactjs-popup";
import "react-toastify/dist/ReactToastify.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import { ProductName } from "../Common/ProductName";
const baseUrl = myConstList.baseUrl;

class FundRequest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mainWallet: 1,

      usdcTabClass: "",
      mrcTabClass: "",
      BTC: false,
      INR: false,
      USDC: false,
      MRC: false,
      coinInrListData: [],
      coinDefultListData: [],
      coinMrcListData: [],
      allData: [],
      showData: [],
      totalBalance: 0,
      defaultValue: "",
      selectedCoin: "",
    };
  }

  componentWillMount() {
    if (!localStorage.id) {
      window.location.href = "/login-to-buy-sell-crypto";
    }

    this.trasactionList();
    this.WalletAllCoinBalance();
  }
  trasactionList = () => {
    let headerData = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };
    axios
      .post(baseUrl + "/frontapi/coinFundRequest", {}, headerData)
      .then((resp1) => {
        var resp = resp1.data;

        if (resp.status) {
          this.setState({
            allData: resp.data,
            trasactionList: resp.data.main_wallet,
            cryptoIdWallet: resp.data.coin_id,
            TransactionsStatus: resp.status,
            defaultValue: resp.data[0].walletSum[0].walletAmount,
            defaultWalletTable: resp.data[0].wallet, //,spotList: resp.data.Spot_wallet,
          });
          this.OpenMain(resp.data[0]);
        }
      });
  };

  WalletAllCoinBalance = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };
    axios
      .get(baseUrl + "/frontapi/wallet_Coin_Total_Balance", config)
      .then((res) => {
        var resp = res.data;
        this.setState({ Status: resp.status, tableData1: resp.data });
      });
  };

  OpenMain = (value) => {
    this.setState({
      INR: false,
      MRC: false,
      BTC: true,
      USDC: false,
      mainWallet: value.coin_id,
      spotTab: "",
      showData: value,
    });
  };

  OpenSpot = (value) => {
    this.setState({
      INR: true,
      MRC: false,
      BTC: false,
      USDC: false,
      mainWallet: "",
      spotTab: "active",
      showData: "inrTable",
    });
  };

  showTableHtml = (value) => {
    console.log(value," = ",this.state.selectedCoin);
    const { t } = this.props;
    if (
      this.state.TransactionsStatus === true &&
      Object.keys(this.state.showData).length > 0
    ) {
      const html = [];
      const filteredTransactions =
        value &&
        value.wallet &&
        value.wallet.filter((e) => e.coinName === this.state.selectedCoin);
        console.log("filteredTransactions = ",filteredTransactions);
      if (filteredTransactions.length > 0) {
        filteredTransactions.forEach((e, i) => {
          html.push(
            <tr>
              <td>{i + 1}</td>
              <td>{e.coin_amount}</td>
              <td>{e.coinName}</td>
              <td>{e.withdrawal_fees}</td>
              <td className="rewidth_t">{e.tx_id}</td>
              <td className="w-t">{t(e.tx_type)}</td>
              
              <td>{Moment.utc(e.created).local().format("lll")}</td>
              <td>
                {e.WithdrawlRequest === "2" ? (
                  <span>
                   {t("Rejected")}{" "}
                    <Popup
                      trigger={<i className="fa fa-info-circle"></i>}
                      position="top center"
                    >
                      <div>{e.reject}</div>
                    </Popup>
                  </span>
                ) : e.WithdrawlRequest === "0" ? (
                  <span> {t("Completed")} </span>
                ) : (
                  t("Pending")
                )}
              </td>
              <td style={{ wordBreak: "break-all" }}>{e.tx_hash}</td>
            </tr>
          );
        });
      } else if (!this.state.selectedCoin) {
        console.log("else if1 == ",value);
        if(value && value.wallet && value.wallet.length) {
        value &&
          value.wallet &&
          value.wallet.forEach((e, i) => {
            html.push(
              <tr>
                <td>{i + 1}</td>
                <td>{e.coin_amount}</td>
                <td>{e.coinName}</td>
                <td>{e.withdrawal_fees}</td>
                <td className="rewidth_t">{e.tx_id}</td>
                <td className="w-t">{t(e.tx_type)}</td>
               
                <td>{Moment.utc(e.created).local().format("lll")}</td>
                <td>
                  {e.WithdrawlRequest === "2" ? (
                    <span>
                       {t("Rejected")}{" "}
                      <Popup
                        trigger={<i className="fa fa-info-circle"></i>}
                        position="top center"
                      >
                        <div>{t(e.rejection_reasion)}</div>
                      </Popup>
                    </span>
                  ) : e.WithdrawlRequest === "0" ? (
                    <span> {t("Completed")} </span>
                  ) : (
                    t("Pending")
                  )}
                </td>
                <td style={{ wordBreak: "break-all" }}>{e.tx_hash}</td>
              </tr>
            );
          });
        }else {
          return (
            <tr>
              <td colSpan={8} className="text-center">
                {t("No Data Found")}
              </td>
            </tr>
          );
        }
      } else {
        return (
          <tr>
            <td colSpan={8} className="text-center">
              {t("No Data Found")}
            </td>
          </tr>
        );
      }
      console.log("else html == ", html);
      return <tbody className="">{html}</tbody>;
    } else {
      return (
        <tr>
          <td colSpan={8} className="text-center">
            {t("No Data Found")}
          </td>
        </tr>
      );
    }
  };

  renderCoinList = (allData) => {
    let { mainWallet } = this.state;
    return allData.map((item, index) => {
      let active = false;
      if (mainWallet == item.coin_id) {
        active = true;
      }
      return (
        <li key={index} onClick={() => this.OpenMain(item)}>
          <span className={active ? "active" : <></>}>{item.name}</span>
        </li>
      );
    });
  };
  handleChange = (e) => {
    const { value } = e.target;
    this.setState({ selectedCoin: value });
  };
  render() {
    const { t } = this.props;
    const meta = {
      title: `Withdrawal Transactions | ${ProductName} Exchange`,
      description: `Login on ${ProductName} Exchange now and start trading! Invite your friends to ${ProductName} Exchange.`,
      meta: {
        charset: "utf-8",
        name: {
          keywords: `${ProductName} Exchange , Crypto Exchange, Buy Sell Crypto, Bitcoin Exchange India`,
        },
      },
    };
    let { selectedCoin, allData } = this.state;
    return (
      <DocumentMeta {...meta}>
        <div>
          <LoginHeader />
          <div className="">
            <div className="bg_light">
              <div className="new_inpage">
                <div className="container container2">
                  {/* <LeftTab /> */}
                  <div className="white_box">
                    <div className="row">
                      <div className="col-md-8 col-lg-9">
                        <ul className="nav nav-tabs2 mb-3 ">
                          <li className="nav-item">
                            <Link to="/transactions"> {t("Main wallet")} </Link>
                          </li>
                          <li className="nav-item">
                            <Link to="/depositeHistory"> {t("Spot")} </Link>
                          </li>
                          <li className="nav-item">
                            <Link to="/coinDeposite"> {t("Deposit")} {t("Coin")}  </Link>
                          </li>
                          <li className="nav-item">
                            <Link to="/coinFundRequest" className="active">
                              {" "}
                              {t("Withdrawal")}{" "}
                            </Link>
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-4 col-lg-3">
                        <select
                          className="form-control"
                          value={selectedCoin}
                          onChange={this.handleChange}
                        >
                          <option value={""}>{t("Select Crypto")}</option>
                          {allData.length > 0 &&
                            allData[0].coinList.map((item) => {
                              return (
                                <option value={item.short_name}>
                                  {item.short_name}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                    </div>

                    <div className="tab-content">
                      <div className="tab-pane active" id="Balance">
                        <div className="top_balance"></div>
                        <div className="rows">
                          <div className="wallet_box">
                            <div className="table-responsive">
                              <div className="scrool_wallet_box">
                                <table className="table table-striped mb-0 ">
                                  <thead>
                                    <tr>
                                      <th>{t("Sr. No.")}</th>
                                      <th>{t("Amount")}</th>
                                      <th>{t("Coin Name")}</th>
                                      <th>{t("Withdrawal Fee")}</th>
                                      <th>{t("Withdrawal Token ID")}</th>
                                      <th>{t("Transaction Type")}</th>                                     
                                      <th>{t("Created At")}</th>
                                      <th>{t("Status")}</th>
                                      <th>{t("Transaction Hash")}</th>
                                    </tr>
                                  </thead>
                                  {this.showTableHtml(this.state.showData)}
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* </div>
          </div> */}
          </div>
          <Footer />
        </div>
      </DocumentMeta>
    );
  }
}

export default withTranslation()(FundRequest);
